import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { useTheme } from "@emotion/react";
import { Link as RouterLink } from "react-router-dom";
import { getPageRoute } from "src/services";

const Waitlist = () => {
  const theme = useTheme();

  return (
    <Box
      component="section"
      id="waitlist"
      sx={{
        // Deep top padding so the transition from the dark Stories section
        // reads as intentional; extra bottom padding creates the breathing
        // room before MaestroFooter.
        pt: { xs: 10, md: 15 },
        pb: { xs: 12, md: 18 },
        bgcolor: theme.palette.paper.primary,
        color: theme.palette.text.primary,
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Soft green glow behind the CTA. Subtle on white, keeps continuity
          with the green accent used throughout the rest of the page. */}
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 900,
          height: 900,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(32,156,51,0.08) 0%, transparent 70%)",
          zIndex: 0,
        }}
      />

      <Container maxWidth="md" sx={{ position: "relative", zIndex: 1 }}>
        <Typography
          component="h2"
          sx={{
            fontSize: { xs: "2.25rem", md: "4rem" },
            fontWeight: 800,
            letterSpacing: "-0.03em",
            lineHeight: 1.06,
            color: theme.palette.text.primary,
            maxWidth: 780,
            mx: "auto",
          }}
        >
          Bring Maestro to{" "}
          <Box component="span" sx={{ color: theme.palette.success.main }}>
            your classroom or district
          </Box>
          .
        </Typography>
        <Typography
          sx={{
            fontSize: "1.1875rem",
            color: theme.palette.text.secondary,
            mt: 2.5,
            maxWidth: 560,
            mx: "auto",
            lineHeight: 1.5,
          }}
        >
          Join the fall 2026 waitlist. We'll ask a few questions about your
          school and get back to you within a week.
        </Typography>

        <Box sx={{ mt: 5.5 }}>
          <Button
            component={RouterLink}
            to={getPageRoute("waitlist", "WAITLIST")}
            variant="contained"
            sx={{
              bgcolor: theme.palette.success.main,
              color: theme.palette.paper.primary,
              px: { xs: 5, md: 6.5 },
              py: { xs: 2.25, md: 2.75 },
              fontSize: { xs: "1.0625rem", md: "1.25rem" },
              fontWeight: 700,
              textTransform: "none",
              borderRadius: 999,
              whiteSpace: "nowrap",
              boxShadow: "0 10px 32px rgba(32,156,51,0.35)",
              "&:hover": {
                bgcolor: "#15803d",
                transform: "translateY(-2px)",
                boxShadow: "0 12px 36px rgba(32,156,51,0.45)",
              },
              transition:
                "background-color 0.15s, box-shadow 0.15s, transform 0.15s",
            }}
          >
            Join the waitlist →
          </Button>
        </Box>

        <Typography
          sx={{
            fontSize: "0.875rem",
            color: theme.palette.text.secondary,
            mt: 3,
            opacity: 0.7,
          }}
        >
          Teacher, school leader, or district partner. One short form on
          the next step.
        </Typography>
      </Container>
    </Box>
  );
};

export default Waitlist;
